const beeFreeDefaults = [
    {
        slug: "BF-simple-template",
        name: "Simple Template",
        default: true,
    },
    {
        slug: "BF-basic-onecolumn",
        name: "Basic One Column Template",
        default: true,
    },
    {
        slug: "BF-basic-standard",
        name: "Standard Basic Template",
        default: true,
    },
    {
        slug: "BF-basic-newsletter",
        name: "Basic Newsletter Template",
        default: true,
    },
    {
        slug: "BF-newsletter-template",
        name: "Newsletter Template",
        default: true,
    },
    {
        slug: "BF-promo-template",
        name: "Promotional Template",
        default: true,
    },
    {
        slug: "BF-basic-e-commerce",
        name: "Basic E-Commerce Template",
        default: true,
    },
    {
        slug: "BF-ecommerce-template",
        name: "E-Commerce Template",
        default: true,
    },
]
export default beeFreeDefaults
